import React, { useState, useCallback } from 'react'

import { TextInput, Button } from 'lensrentals-components'

import styles from './styles.module.scss'

const UNSUBMITTED = 'unsubmitted'
const SUBMITTED = 'submitted'
const ERROR = 'error'

export default function EmailSignupForm({ submit, type = '' }) {
  const [email, setEmail] = useState('')

  const [response, setResponse] = useState()
  const [state, setState] = useState(UNSUBMITTED)
  const [errorMsg, setErrorMsg] = useState(null)

  const handleEmail = useCallback((event) => {
    setEmail(event.target.value)
  }, [setEmail])

  const handleSubmit = async (event) => {
    event.preventDefault()

    try {
      setResponse(await submit(email))
      setState(SUBMITTED)
    } catch (error) {
      setErrorMsg(error.error)
      setState(ERROR)
    }
  }

  const reset = () => {
    setState(UNSUBMITTED)
    setEmail('')
  }

  switch (state) {
    case ERROR:
      return (
        <div className={styles.message}>
          <strong>{errorMsg || 'Uh oh, something went wrong.'}</strong>
          <Button onClick={() => window.location.reload()}>Try Again?</Button>
        </div>
      )
    case SUBMITTED:
      return (
        <div className={styles.message}>
          <strong className='email_signup_response_text'>{response}</strong>
          { type === 'newsletter' &&
            <Button onClick={reset} color='confirm'>Add Another Email?</Button>
          }
        </div>
      )
    default:
      return (
        <form
          className={styles['signup-form']}
          onSubmit={handleSubmit}
        >
          <TextInput
            type='email'
            id='email'
            placeholder='Enter your email address'
            value={email}
            onChange={handleEmail}
            className={styles['email-input']}
            />
          <Button
            type='submit'
            color='confirm'
            className={styles['signup-button']}
          >
            Sign Up
          </Button>
        </form>
      )
  }
}
